import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
import { TextFormat, TextFormatAlign } from '@awayjs/scene';
import { FontLookUpMode } from '@awayjs/scene';
import { TextBaseline } from './TextBaseline';
import { Debug } from '@awayjs/core';
var noLogs = true;
var elementFormatIDs = 0;
var ElementFormat = /** @class */ (function (_super) {
    __extends(ElementFormat, _super);
    function ElementFormat(fontDescription, fontSize, color, alpha, textRotation, dominantBaseline, alignmentBaseline, baselineShift, kerning, trackingRight, trackingLeft, locale, breakOpportunity, digitCase, digitWidth, ligatureLevel, typographicCase) {
        if (fontDescription === void 0) { fontDescription = null; }
        if (fontSize === void 0) { fontSize = 12; }
        if (color === void 0) { color = 0; }
        if (alpha === void 0) { alpha = 1; }
        if (textRotation === void 0) { textRotation = 'auto'; }
        if (dominantBaseline === void 0) { dominantBaseline = 'roman'; }
        if (alignmentBaseline === void 0) { alignmentBaseline = 'useDominantBaseline'; }
        if (baselineShift === void 0) { baselineShift = 0; }
        if (kerning === void 0) { kerning = 'on'; }
        if (trackingRight === void 0) { trackingRight = 0; }
        if (trackingLeft === void 0) { trackingLeft = 0; }
        if (locale === void 0) { locale = 'en'; }
        if (breakOpportunity === void 0) { breakOpportunity = 'auto'; }
        if (digitCase === void 0) { digitCase = 'default'; }
        if (digitWidth === void 0) { digitWidth = 'default'; }
        if (ligatureLevel === void 0) { ligatureLevel = 'common'; }
        if (typographicCase === void 0) { typographicCase = 'default'; }
        var _this = _super.call(this) || this;
        _this._id = elementFormatIDs++;
        noLogs || console.log('[ElementFormat] ' + _this._id + ' constructor', 'fontDescription', fontDescription, 'fontSize', fontSize, 'color', color, 'alpha', alpha, 'textRotation', textRotation, 'dominantBaseline', dominantBaseline, 'alignmentBaseline', alignmentBaseline, 'baselineShift', baselineShift, 'kerning', kerning, 'trackingRight', trackingRight, 'trackingLeft', trackingLeft, 'locale', locale, 'breakOpportunity', breakOpportunity, 'digitCase', digitCase, 'digitWidth', digitWidth, 'ligatureLevel', ligatureLevel, 'typographicCase', typographicCase);
        _this._fontDescription = fontDescription;
        _this._fontSize = +fontSize;
        _this._color = color >>> 0;
        _this._alpha = +alpha;
        _this._textRotation = axCoerceString(textRotation);
        _this._dominantBaseline = axCoerceString(dominantBaseline);
        _this._alignmentBaseline = axCoerceString(alignmentBaseline);
        _this._baselineShift = +baselineShift;
        _this._kerning = axCoerceString(kerning);
        _this._trackingRight = +trackingRight;
        _this._trackingLeft = +trackingLeft;
        _this._locale = axCoerceString(locale);
        _this._breakOpportunity = axCoerceString(breakOpportunity);
        _this._digitCase = axCoerceString(digitCase);
        _this._digitWidth = axCoerceString(digitWidth);
        _this._ligatureLevel = axCoerceString(ligatureLevel);
        _this._typographicCase = axCoerceString(typographicCase);
        return _this;
    }
    ElementFormat.prototype.createAwayTextformat = function () {
        var _a, _b, _c;
        var awayTextFormat = new TextFormat();
        awayTextFormat.size = this._fontSize;
        awayTextFormat.color = this._color;
        awayTextFormat.fontLookUpMode = (this._fontDescription ?
            this._fontDescription.fontLookup : FontLookUpMode.DEVICE);
        awayTextFormat.font_name = (_a = this._fontDescription) === null || _a === void 0 ? void 0 : _a.fontName;
        awayTextFormat.italic = ((_b = this._fontDescription) === null || _b === void 0 ? void 0 : _b.fontPosture) == 'italic';
        awayTextFormat.bold = ((_c = this._fontDescription) === null || _c === void 0 ? void 0 : _c.fontWeight) == 'bold';
        awayTextFormat.align = TextFormatAlign.LEFT;
        if (this._baselineShift != 0) {
            console.warn('baselineshift is not 0', this._baselineShift);
        }
        if (this._alignmentBaseline != TextBaseline.USE_DOMINANT_BASELINE) {
            console.warn('_alignmentBaseline is not USE_DOMINANT_BASELINE', this._alignmentBaseline);
        }
        if (this._dominantBaseline != TextBaseline.ROMAN) {
            console.warn('_dominantBaseline is not ROMAN', this._dominantBaseline);
        }
        if (this._trackingRight != 0) {
            console.warn('_trackingRight is not 0', this._trackingRight);
        }
        if (this._trackingLeft != 0) {
            console.warn('_trackingLeft is not 0', this._trackingLeft);
        }
        if (this._alpha != 1) {
            console.warn('_alpha is not 1', this._alpha);
        }
        if (this._digitCase != 'default') {
            console.warn('_digitCase is not "default"', this._digitCase);
        }
        if (this._digitWidth != 'default') {
            console.warn('_digitWidth is not "default"', this._digitWidth);
        }
        if (this._typographicCase != 'default') {
            console.warn('_typographicCase is not "default"', this._typographicCase);
        }
        if (this._ligatureLevel != 'common') {
            console.warn('_ligatureLevel is not "common"', this._ligatureLevel);
        }
        noLogs || console.log('[ElementFormat] ' + this._id + ' createAwayTextformat', awayTextFormat.id, 'fontDescription', this._fontDescription, 'fontSize', this._fontSize, 'color', this._color, 'alpha', this._alpha, 'textRotation', this._textRotation, 'dominantBaseline', this._dominantBaseline, 'alignmentBaseline', this._alignmentBaseline, 'baselineShift', this._baselineShift, 'kerning', this._kerning, 'trackingRight', this._trackingRight, 'trackingLeft', this._trackingLeft, 'locale', this._locale, 'breakOpportunity', this._breakOpportunity, 'digitCase', this._digitCase, 'digitWidth', this._digitWidth, 'ligatureLevel', this._ligatureLevel, 'typographicCase', this._typographicCase);
        return awayTextFormat;
    };
    // AS -> JS Bindings
    ElementFormat.prototype.getBaseline = function () {
        if (this._alignmentBaseline == TextBaseline.USE_DOMINANT_BASELINE) {
            return this._dominantBaseline;
        }
        return this._alignmentBaseline;
    };
    Object.defineProperty(ElementFormat.prototype, "alignmentBaseline", {
        get: function () {
            return this._alignmentBaseline;
        },
        set: function (alignmentBaseline) {
            this._alignmentBaseline = axCoerceString(alignmentBaseline);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "alpha", {
        get: function () {
            return this._alpha;
        },
        set: function (value) {
            this._alpha = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "baselineShift", {
        get: function () {
            return this._baselineShift;
        },
        set: function (value) {
            this._baselineShift = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "breakOpportunity", {
        get: function () {
            return this._breakOpportunity;
        },
        set: function (opportunityType) {
            this._breakOpportunity = axCoerceString(opportunityType);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value /*uint*/) {
            this._color = value >>> 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "dominantBaseline", {
        get: function () {
            return this._dominantBaseline;
        },
        set: function (dominantBaseline) {
            this._dominantBaseline = axCoerceString(dominantBaseline);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "fontDescription", {
        get: function () {
            return this._fontDescription;
        },
        set: function (value) {
            this._fontDescription = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "digitCase", {
        get: function () {
            return this._digitCase;
        },
        set: function (digitCaseType) {
            this._digitCase = axCoerceString(digitCaseType);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "digitWidth", {
        get: function () {
            return this._digitWidth;
        },
        set: function (digitWidthType) {
            this._digitWidth = axCoerceString(digitWidthType);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "ligatureLevel", {
        get: function () {
            return this._ligatureLevel;
        },
        set: function (ligatureLevelType) {
            this._ligatureLevel = axCoerceString(ligatureLevelType);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "fontSize", {
        get: function () {
            return this._fontSize;
        },
        set: function (value) {
            this._fontSize = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "kerning", {
        get: function () {
            return this._kerning;
        },
        set: function (value) {
            this._kerning = axCoerceString(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "locale", {
        get: function () {
            return this._locale;
        },
        set: function (value) {
            this._locale = axCoerceString(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "textRotation", {
        get: function () {
            return this._textRotation;
        },
        set: function (value) {
            this._textRotation = axCoerceString(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "trackingRight", {
        get: function () {
            return this._trackingRight;
        },
        set: function (value) {
            this._trackingRight = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "trackingLeft", {
        get: function () {
            return this._trackingLeft;
        },
        set: function (value) {
            this._trackingLeft = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "typographicCase", {
        get: function () {
            return this._typographicCase;
        },
        set: function (typographicCaseType) {
            this._typographicCase = axCoerceString(typographicCaseType);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "locked", {
        get: function () {
            return this._locked;
        },
        set: function (value) {
            this._locked = value;
        },
        enumerable: false,
        configurable: true
    });
    ElementFormat.prototype.getFontMetrics = function () {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/ElementFormat', 'set getFontMetrics', '');
        return null;
    };
    ElementFormat.forceNativeConstructor = true;
    ElementFormat.forceNativeMethods = true;
    return ElementFormat;
}(ASObject));
export { ElementFormat };
